<div
  class="form-wrapper-alt error-wrapper"
  *ngIf="(serverNotResponding$ | async) as errorData"
>
  <div class="wrapper">
    <div class="content">
      <div class="main">
        <div class="form-wrapper-content">
          <a class="form-wrapper-header">
            <span class="logo"></span>
            <span class="form-wrapper-header-txt">CoinDepo</span>
          </a>
          <div class="form-wrapper-body">
            <div>
              <h3>
                {{'shared.server-not-respond.an-error-occurred' | translate}}
              </h3>
              <p>
                {{'shared.server-not-respond.we-are-aware-of-problem' | translate}}
              </p>
              <p>
                {{'shared.server-not-respond.please-try-again-late' | translate}}
              </p>
              <p>
                Error Code: {{errorData.code}}
                Parent ID: {{errorData.parent_id}}
              </p>
              <button
                type="submit"
                class="btn btn-secondary btn-lg btn-min-w"
                (click)="refresh()"
              >
                {{'shared.server-not-respond.refresh' | translate}}
              </button>
            </div>
            <div>
              <img
                class="img-form-wrapper-body"
                [src]="staticUrl + 'assets/images/404robot.png'"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
